"use client";

import { useLocale, useTranslations } from "next-intl";

/** Пояснение для EN: расчёты в сомони, USD — ориентир по курсу. */
export default function TjsUsdDisclaimer({ className = "" }: { className?: string }) {
  const locale = useLocale();
  const t = useTranslations("Pricing");

  if (locale !== "en") return null;

  return (
    <p className={`text-[11px] leading-snug text-gray-500 dark:text-gray-400 ${className}`}>
      {t("usdDisclaimer")}
    </p>
  );
}
